"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardWeightChangeSnapshot = exports.AllianceAsset = exports.RewardWeightRange = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../../google/protobuf/duration");
const timestamp_1 = require("../../google/protobuf/timestamp");
const params_1 = require("./params");
exports.protobufPackage = "alliance.alliance";
const baseRewardWeightRange = { min: "", max: "" };
exports.RewardWeightRange = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.min !== "") {
            writer.uint32(10).string(message.min);
        }
        if (message.max !== "") {
            writer.uint32(18).string(message.max);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRewardWeightRange);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.min = reader.string();
                    break;
                case 2:
                    message.max = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRewardWeightRange);
        message.min =
            object.min !== undefined && object.min !== null ? String(object.min) : "";
        message.max =
            object.max !== undefined && object.max !== null ? String(object.max) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.min !== undefined && (obj.min = message.min);
        message.max !== undefined && (obj.max = message.max);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseRewardWeightRange);
        message.min = (_a = object.min) !== null && _a !== void 0 ? _a : "";
        message.max = (_b = object.max) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseAllianceAsset = {
    denom: "",
    rewardWeight: "",
    takeRate: "",
    totalTokens: "",
    totalValidatorShares: "",
    rewardChangeRate: "",
    isInitialized: false,
};
exports.AllianceAsset = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.rewardWeight !== "") {
            writer.uint32(18).string(message.rewardWeight);
        }
        if (message.takeRate !== "") {
            writer.uint32(26).string(message.takeRate);
        }
        if (message.totalTokens !== "") {
            writer.uint32(34).string(message.totalTokens);
        }
        if (message.totalValidatorShares !== "") {
            writer.uint32(42).string(message.totalValidatorShares);
        }
        if (message.rewardStartTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.rewardStartTime), writer.uint32(50).fork()).ldelim();
        }
        if (message.rewardChangeRate !== "") {
            writer.uint32(58).string(message.rewardChangeRate);
        }
        if (message.rewardChangeInterval !== undefined) {
            duration_1.Duration.encode(message.rewardChangeInterval, writer.uint32(66).fork()).ldelim();
        }
        if (message.lastRewardChangeTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastRewardChangeTime), writer.uint32(74).fork()).ldelim();
        }
        if (message.rewardWeightRange !== undefined) {
            exports.RewardWeightRange.encode(message.rewardWeightRange, writer.uint32(82).fork()).ldelim();
        }
        if (message.isInitialized === true) {
            writer.uint32(88).bool(message.isInitialized);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAllianceAsset);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.rewardWeight = reader.string();
                    break;
                case 3:
                    message.takeRate = reader.string();
                    break;
                case 4:
                    message.totalTokens = reader.string();
                    break;
                case 5:
                    message.totalValidatorShares = reader.string();
                    break;
                case 6:
                    message.rewardStartTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.rewardChangeRate = reader.string();
                    break;
                case 8:
                    message.rewardChangeInterval = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.lastRewardChangeTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.rewardWeightRange = exports.RewardWeightRange.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.isInitialized = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAllianceAsset);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.rewardWeight =
            object.rewardWeight !== undefined && object.rewardWeight !== null
                ? String(object.rewardWeight)
                : "";
        message.takeRate =
            object.takeRate !== undefined && object.takeRate !== null
                ? String(object.takeRate)
                : "";
        message.totalTokens =
            object.totalTokens !== undefined && object.totalTokens !== null
                ? String(object.totalTokens)
                : "";
        message.totalValidatorShares =
            object.totalValidatorShares !== undefined &&
                object.totalValidatorShares !== null
                ? String(object.totalValidatorShares)
                : "";
        message.rewardStartTime =
            object.rewardStartTime !== undefined && object.rewardStartTime !== null
                ? fromJsonTimestamp(object.rewardStartTime)
                : undefined;
        message.rewardChangeRate =
            object.rewardChangeRate !== undefined && object.rewardChangeRate !== null
                ? String(object.rewardChangeRate)
                : "";
        message.rewardChangeInterval =
            object.rewardChangeInterval !== undefined &&
                object.rewardChangeInterval !== null
                ? duration_1.Duration.fromJSON(object.rewardChangeInterval)
                : undefined;
        message.lastRewardChangeTime =
            object.lastRewardChangeTime !== undefined &&
                object.lastRewardChangeTime !== null
                ? fromJsonTimestamp(object.lastRewardChangeTime)
                : undefined;
        message.rewardWeightRange =
            object.rewardWeightRange !== undefined &&
                object.rewardWeightRange !== null
                ? exports.RewardWeightRange.fromJSON(object.rewardWeightRange)
                : undefined;
        message.isInitialized =
            object.isInitialized !== undefined && object.isInitialized !== null
                ? Boolean(object.isInitialized)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.rewardWeight !== undefined &&
            (obj.rewardWeight = message.rewardWeight);
        message.takeRate !== undefined && (obj.takeRate = message.takeRate);
        message.totalTokens !== undefined &&
            (obj.totalTokens = message.totalTokens);
        message.totalValidatorShares !== undefined &&
            (obj.totalValidatorShares = message.totalValidatorShares);
        message.rewardStartTime !== undefined &&
            (obj.rewardStartTime = message.rewardStartTime.toISOString());
        message.rewardChangeRate !== undefined &&
            (obj.rewardChangeRate = message.rewardChangeRate);
        message.rewardChangeInterval !== undefined &&
            (obj.rewardChangeInterval = message.rewardChangeInterval
                ? duration_1.Duration.toJSON(message.rewardChangeInterval)
                : undefined);
        message.lastRewardChangeTime !== undefined &&
            (obj.lastRewardChangeTime = message.lastRewardChangeTime.toISOString());
        message.rewardWeightRange !== undefined &&
            (obj.rewardWeightRange = message.rewardWeightRange
                ? exports.RewardWeightRange.toJSON(message.rewardWeightRange)
                : undefined);
        message.isInitialized !== undefined &&
            (obj.isInitialized = message.isInitialized);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = Object.assign({}, baseAllianceAsset);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.rewardWeight = (_b = object.rewardWeight) !== null && _b !== void 0 ? _b : "";
        message.takeRate = (_c = object.takeRate) !== null && _c !== void 0 ? _c : "";
        message.totalTokens = (_d = object.totalTokens) !== null && _d !== void 0 ? _d : "";
        message.totalValidatorShares = (_e = object.totalValidatorShares) !== null && _e !== void 0 ? _e : "";
        message.rewardStartTime = (_f = object.rewardStartTime) !== null && _f !== void 0 ? _f : undefined;
        message.rewardChangeRate = (_g = object.rewardChangeRate) !== null && _g !== void 0 ? _g : "";
        message.rewardChangeInterval =
            object.rewardChangeInterval !== undefined &&
                object.rewardChangeInterval !== null
                ? duration_1.Duration.fromPartial(object.rewardChangeInterval)
                : undefined;
        message.lastRewardChangeTime = (_h = object.lastRewardChangeTime) !== null && _h !== void 0 ? _h : undefined;
        message.rewardWeightRange =
            object.rewardWeightRange !== undefined &&
                object.rewardWeightRange !== null
                ? exports.RewardWeightRange.fromPartial(object.rewardWeightRange)
                : undefined;
        message.isInitialized = (_j = object.isInitialized) !== null && _j !== void 0 ? _j : false;
        return message;
    },
};
const baseRewardWeightChangeSnapshot = { prevRewardWeight: "" };
exports.RewardWeightChangeSnapshot = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.prevRewardWeight !== "") {
            writer.uint32(10).string(message.prevRewardWeight);
        }
        for (const v of message.rewardHistories) {
            params_1.RewardHistory.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRewardWeightChangeSnapshot);
        message.rewardHistories = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.prevRewardWeight = reader.string();
                    break;
                case 2:
                    message.rewardHistories.push(params_1.RewardHistory.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseRewardWeightChangeSnapshot);
        message.prevRewardWeight =
            object.prevRewardWeight !== undefined && object.prevRewardWeight !== null
                ? String(object.prevRewardWeight)
                : "";
        message.rewardHistories = ((_a = object.rewardHistories) !== null && _a !== void 0 ? _a : []).map((e) => params_1.RewardHistory.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.prevRewardWeight !== undefined &&
            (obj.prevRewardWeight = message.prevRewardWeight);
        if (message.rewardHistories) {
            obj.rewardHistories = message.rewardHistories.map((e) => e ? params_1.RewardHistory.toJSON(e) : undefined);
        }
        else {
            obj.rewardHistories = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseRewardWeightChangeSnapshot);
        message.prevRewardWeight = (_a = object.prevRewardWeight) !== null && _a !== void 0 ? _a : "";
        message.rewardHistories = ((_b = object.rewardHistories) !== null && _b !== void 0 ? _b : []).map((e) => params_1.RewardHistory.fromPartial(e));
        return message;
    },
};
function toTimestamp(date) {
    const seconds = numberToLong(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function numberToLong(number) {
    return long_1.default.fromNumber(number);
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
